import { defineMessages } from "react-intl";

const messages = defineMessages({
    title1: {
        id: "intro.solfaname.1.title",
    },
    title2: {
        id: "intro.solfaname.3.title",
    },
    title3: {
        id: "intro.solfaname.4.title",
    },
    description1: {
        id: "intro.singing.1.description",
    },
    description2: {
        id: "intro.singing.2.description",
    },
    description3: {
        id: "intro.singing.3.description",
    },
});

export default messages;
